import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'
import { breakpoint, pxToRem, size } from '@twistopayments/design-system/styles'

export const wrap = css`
  max-width: 1920px;
  margin: ${size[24]};

  ${breakpoint.up('smMd')} {
    text-align: center;
    margin: ${size[80]} auto;
  }
`

export const title = (theme: Theme) => css`
  font-size: ${pxToRem(28)};
  font-weight: 700;
  margin-bottom: ${size[32]};
  line-height: 32px;
  color: ${theme.palette.text.title};

  ${breakpoint.up('smMd')} {
    line-height: 100%;
    font-size: ${pxToRem(48)};
    margin-bottom: ${size[40]};
  }

  span {
    color: ${theme.palette.primary.mainContrast};
  }
`

export const desc = (theme: Theme) => css`
  margin-bottom: ${size[32]};
  line-height: 24px;
  color: ${theme.palette.tertiary.upperMediumContrast};
  font-size: ${pxToRem(17)};

  ${breakpoint.up('smMd')} {
    line-height: 100%;
    font-size: ${pxToRem(22)};
    margin-bottom: ${size[40]};
  }
`
